import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { useRootDispatch } from "store/hooks";
import { updateSlide } from "store/common/common-slice";
import { PaymentMethod } from "store/paymentMethods/paymentMethods-state";

import { PAYMENT_METHOD_TYPE, isExpired } from "utility";

import classes from "./PaymentMethodCard.module.scss";

export interface PaymentMethodProps {
  autoPay?: boolean;
  title: string;
  detail: string;
  type?: number;
  hideActions?: boolean;
  expiryDate?: string;
  data?: PaymentMethod;
}

export const PaymentMethodCard: React.FC<PaymentMethodProps> = ({
  autoPay,
  title,
  detail,
  type,
  hideActions,
  expiryDate,
  data,
}) => {
  const menuRef = useRef<any>();
  const dispatch = useRootDispatch();
  const { t } = useTranslation(["common", "payment_next"]);
  const menuClickHandler = () => {
    if (menuRef.current) menuRef.current.open = !menuRef.current.open;
  };

  const renderIcons = (type?: number) => {
    if (type === PAYMENT_METHOD_TYPE.card) {
      return <ft-icon> credit_card</ft-icon>;
    }
    if (type === PAYMENT_METHOD_TYPE.eWallet) {
      return <ft-icon> account_balance_wallet</ft-icon>;
    }
    return <ft-icon> account_balance</ft-icon>;
  };

  return (
    <div className={classes.PaymentMethod}>
      <div className={classes.Icon}>{renderIcons(type)}</div>
      <div className={classes.PaymentDetails}>
        <p
          data-testid="payment-method-payment-heading"
          className={classes.Heading}
        >
          {title}
        </p>
        <p className={classes.Name}>{detail}</p>
        {expiryDate ? (
          <p className={classes.Expiry}>
            {t("payment_next:expired_on")}:{" "}
            <span className={isExpired(expiryDate) ? classes.Expired : ""}>
              {expiryDate}
            </span>
          </p>
        ) : null}
        <p className={classes.Autopay}>
          {t("common:autopay_label")}:{" "}
          {autoPay ? (
            <span className={classes.autoPayStatusOn}>{t("common:on")}</span>
          ) : (
            <span className={classes.autoPayStatusOff}>{t("common:off")}</span>
          )}
        </p>
      </div>
      <div className={classes.Setting}>
        {hideActions ? null : (
          <div className={classes.IconWrapper}>
            <ft-icon-button
              onClick={menuClickHandler}
              class={classes.SettingIcon}
              icon="settings"
              data-testid="payment-method-action-icon"
              title={t("manage_wallet")}
            ></ft-icon-button>
            <ft-menu
              absolute
              class={classes.ListMenu}
              ref={menuRef}
              x="-30"
              y="0"
              data-testid="payment-method-action-menu"
            >
              {/* {type === PAYMENT_METHOD_TYPE.card ? (
                <ft-list-item
                  onClick={() => {
                    dispatch(
                      updateSlide({
                        id: "AddPaymentMethods",
                        tab: 1,
                        data,
                      })
                    );
                  }}
                >
                  {t("common:edit")}
                </ft-list-item>
              ) : null} */}
              <ft-list-item
                data-testid="payment-methods-payment-method-delete-item"
                onClick={() =>
                  dispatch(updateSlide({ id: "DeleteConfirmation", data }))
                }
              >
                {t("common:delete")}
              </ft-list-item>
            </ft-menu>
          </div>
        )}
      </div>
    </div>
  );
};
